import api from "./api";

// ── Hostels ────────────────────────────────────────────────────────────────
export const getHostels = () => api.get("/hostels");
export const getHostelById = (id) => api.get(`/hostels/${id}`);
export const createHostel = (data) => api.post("/hostels", data);
export const updateHostel = (id, data) => api.put(`/hostels/${id}`, data);
export const deleteHostel = (id) => api.delete(`/hostels/${id}`);
export const getOccupancySummary = () => api.get("/hostels/occupancy-summary");

// ── Rooms ──────────────────────────────────────────────────────────────────
export const getRooms = (hostelId) =>
    api.get("/rooms", { params: hostelId ? { hostel: hostelId } : {} });
export const getRoomById = (id) => api.get(`/rooms/${id}`);
export const createRoom = (data) => api.post("/rooms", data);
export const updateRoom = (id, data) => api.put(`/rooms/${id}`, data);
export const deleteRoom = (id) => api.delete(`/rooms/${id}`);

// ── Allocations ────────────────────────────────────────────────────────────
// params can include: { hostel, room, status }
export const getAllocations = (params) => api.get("/hostel-allocations", { params });
export const getAllocationsByStudent = (studentId) =>
    api.get(`/hostel-allocations/student/${studentId}`);
export const allocateStudent = (data) => api.post("/hostel-allocations", data);
export const vacateStudent = (id) => api.put(`/hostel-allocations/${id}/vacate`);
export const reallocateStudent = (id, data) =>
    api.put(`/hostel-allocations/${id}/reallocate`, data);
export const waiveHostelMonth = (id, data) =>
    api.put(`/hostel-allocations/${id}/waive-month`, data);
export const unWaiveHostelMonth = (id, monthYear) =>
    api.delete(`/hostel-allocations/${id}/waive-month/${monthYear}`);


// Hostel fee structures
export const getHostelFeeStructures = (params) =>
    api.get("/hostel-fee-structures", { params });
export const getApplicableHostelFeeStructure = (params) =>
    api.get("/hostel-fee-structures/applicable", { params });
export const createHostelFeeStructure = (data) =>
    api.post("/hostel-fee-structures", data);
export const updateHostelFeeStructure = (id, data) =>
    api.put(`/hostel-fee-structures/${id}`, data);
export const deleteHostelFeeStructure = (id) =>
    api.delete(`/hostel-fee-structures/${id}`);

// Hostel fee receipts
export const getHostelFeeReceipts = (params) =>
    api.get("/hostel-fee-receipts", { params });
export const getHostelFeeReceiptsByStudent = (studentId, params) =>
    api.get(`/hostel-fee-receipts/student/${studentId}`, { params });
export const createHostelFeeReceipt = (data) =>
    api.post("/hostel-fee-receipts", data);
export const getPendingHostelFees = (params) =>
    api.get("/hostel-fee-receipts/pending", { params });

// ── Student search (reuses your existing /students list endpoint) ─────────
// NOTE: adjust the param name ("search") and response path if your actual
// /students endpoint differs — this mirrors the search-box pattern used
// for teacher assignment in SubjectForm.
export const searchStudents = (query) =>
    api.get("/students", { params: { search: query, limit: 15 } });
